import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, keyBy, noop } from 'lodash';

import IconButton from '~/components/core/Atomic/Buttons/IconButton';
import InputAdornment from '~/components/core/Atomic/InputAdornment';
import ListItemText from '~/components/core/Atomic/ListItemText';
import MenuItem from '~/components/core/Atomic/MenuItem';
import SingleSelectField from '~/components/core/Molecules/Fields/SingleSelectField';
import { CloseIcon_Deprecated } from '~/components/icons';
import Checkbox from '~/components/ui/atoms/Checkbox';

import useOrganization from '../../OrganizationContext';

import { useStyles } from '../../../assets/styles';

const SubOrganizationMultiSelect = ({ onChange = noop, disabled = false }) => {
  const { subOrganizationEnabled, subOrganizations } = useOrganization();
  const { classes } = useStyles();
  const [selectedSubOrgIds, setSelectedSubOrgIds] = useState([]);
  const subOrgsDict = keyBy(subOrganizations, 'id');

  if (!subOrganizationEnabled) {
    return null;
  }

  const handleSelectionChanged = (subOrgIds) => {
    setSelectedSubOrgIds(subOrgIds);
    if (onChange) {
      onChange(subOrgIds);
    }
  };

  const isSubOrgChecked = (subOrgId) => {
    return selectedSubOrgIds.includes(subOrgId);
  };

  const renderFieldValue = (subOrgIds) => {
    return subOrgIds.map((subOrgId) => subOrgsDict[subOrgId].name).join(', ');
  };

  return (
    <SingleSelectField
      value={selectedSubOrgIds}
      label="Sub Organizations"
      className={classes.textField}
      fullWidth
      disabled={disabled}
      onChange={handleSelectionChanged}
      SelectProps={{
        multiple: true,
        renderValue: renderFieldValue,
      }}
      InputProps={{
        endAdornment: isEmpty(selectedSubOrgIds) ? null : (
          <InputAdornment className="mr-24" position="start">
            <IconButton className="p-8" onClick={() => handleSelectionChanged([])}>
              <CloseIcon_Deprecated size={10} />
            </IconButton>
          </InputAdornment>
        ),
      }}
    >
      {subOrganizations.map((subOrg) => (
        <MenuItem key={subOrg.id} value={subOrg.id}>
          <Checkbox checked={isSubOrgChecked(subOrg.id)} />
          <ListItemText primary={subOrg.name} />
        </MenuItem>
      ))}
    </SingleSelectField>
  );
};

SubOrganizationMultiSelect.propTypes = {
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export default SubOrganizationMultiSelect;
